import React from 'react'
import InfoIcon from '@material-ui/icons/Info';
import {Tooltip} from '@material-ui/core'

import useStyles from './styles'

export default function HelpIcon(props){
    const {tooltip, tooltipStyle} = props
    const classes = useStyles({tooltipStyle})
    return (
            <div className={classes.icon} id='MEDCAL_RX_INFO_ICON'>
                <Tooltip classes={{tooltip: classes.tooltip}} title={tooltip} arrow>
                    <InfoIcon />
                </Tooltip>
            </div>
    )
}